import React from 'react'

export const Datenschutz = () => {
    return (
        <div className="law-container">
            <h1>Datenschutzerklärung für die Webseite</h1>

           

    <h1>Datenschutzerklärung</h1>
    
    <h2>1. Einleitung</h2>
    <p>
    Mit den folgenden Informationen möchten wir Ihnen als "betroffener Person" einen Überblick über die Verarbeitung Ihrer personenbezogenen Daten durch uns und Ihre Rechte aus den Datenschutzgesetzen geben. 

Eine Nutzung unserer Internetseiten ist grundsätzlich ohne Eingabe personenbezogener Daten möglich. Sofern Sie besondere Services unseres Unternehmens über unsere Internetseite in Anspruch nehmen möchten, könnte jedoch eine Verarbeitung personenbezogener Daten erforderlich werden. Ist die Verarbeitung personenbezogener Daten erforderlich und besteht für eine solche Verarbeitung keine gesetzliche Grundlage, holen wir generell eine Einwilligung von Ihnen ein.

    </p>
    <h2>2. Verantwortlicher</h2>
    <p>
    Die verantwortliche Stelle für die Datenverarbeitung auf dieser Webseite ist:
    </p>
    <p>ZAC Service und Dienstleistungs GmbH<br/>
       An den Freiheitswiesen 2-4<br/>
       13597 Berlin</p>
    <p>Telefon: +493033607049<br/>
       E-Mail: dispo-berlin@zac.gmbh</p>
    
    <h2>3. Datenschutzbeauftragte</h2>
    <p>Externe Datenschutzbeauftragte<br/>
       c/o TÜV SÜD Akademie GmbH<br/>
       Westendstraße 160<br/>
       80339 München<br/>
       E-Mail: datenschutz@zac.gmbh</p>

       <p>
       Sie können sich jederzeit bei allen Fragen und Anregungen zum Datenschutz direkt an unsere Datenschutzbeauftragte wenden.
       </p>
    
    <h2>4. Verarbeitung Ihrer personenbezogenen Daten</h2>
    <p>
    ZAC erhebt, verarbeitet und speichert Ihre personenbezogenen Daten nur dann, wenn dies aufgrund gesetzlicher Vorschriften erlaubt ist oder Sie Ihre Einwilligung dazu gegeben haben. Diese Daten erhalten wir auf zwei Wegen: Entweder Sie haben uns die Daten mitgeteilt oder wir erheben sie bei der Nutzung unserer Dienste.
    </p>
    <h3>4.1 Daten, die Sie uns mitteilen</h3>
    <p>
    In der Regel können Sie unsere Webseite nutzen, ohne dass Sie uns persönliche Informationen direkt mitteilen. Für einige Dienste werden wir von Ihnen persönliche Informationen erfragen, um den jeweiligen Dienst schnell und nutzerfreundlich abwickeln zu können oder den Service überhaupt anbieten zu können. Detaillierte Informationen zu allen Diensten, die von ZAC auf dieser Webseite angeboten werden, finden Sie in Kapitel 10.
    </p>
    
    <h3>4.2 Daten, die wir durch Ihre Nutzung unserer Dienste erhalten</h3>
    <p>Einige Daten fallen automatisch und aus technischen Gründen bereits dann an, wenn Sie unsere Webseite besuchen. Dies sind regelmäßig Daten, die Ihr Browser an unseren Server übermittelt ("in sog. Server-Logfiles"). Unsere Internetseite erfasst mit jedem Aufruf einer Seite durch Sie oder ein automatisiertes System eine Reihe von allgemeinen Daten und Informationen. Diese allgemeinen Daten und Informationen werden in den Logfiles des Servers gespeichert. Erfasst werden können:</p>
    <ul>
        <li>Verwendeter Browser</li>
        <li>Verwendetes Betriebssystem</li>
        <li>Quelle/Verweis, von welchem der auf die Seite gelangte</li>
        <li>Datum und Uhrzeit des Zugriffes</li>
        <li>Verwendete IP-Adresse</li>
        <li>Internet-Service-Provider</li>
    </ul>

    <p>
    Bei der Nutzung dieser allgemeinen Daten und Informationen ziehen wir keine Rückschlüsse auf Ihre Person. Diese Informationen werden vielmehr benötigt, um
    </p>
    <ul>
        <li>
        die Inhalte unserer Internetseite korrekt auszuliefern,
        </li>
        <li>
        die dauerhafte Funktionsfähigkeit unserer IT-Systeme und der Technik unserer Internetseite zu gewährleisten sowie
        </li>
        <li>
        um Strafverfolgungsbehörden im Falle eines Cyberangriffes die zur Strafverfolgung notwendigen Informationen bereitzustellen
        </li>
    </ul>

    <p>
    Diese erhobenen Daten und Informationen werden durch uns daher einerseits statistisch und ferner mit dem Ziel ausgewertet, den Datenschutz und die Datensicherheit in unserem Unternehmen zu erhöhen, um letztlich ein optimales Schutzniveau für die von uns verarbeiteten personenbezogenen Daten sicherzustellen. Die Daten der Server-Logfiles werden getrennt von allen durch eine betroffene Person angegebenen personenbezogenen Daten gespeichert.

Die Rechtsgrundlage für die Datenverarbeitung ist Art. 6 Abs. 1 S. 1 lit. f) DS-GVO. Unser berechtigtes Interesse folgt aus oben aufgelisteten Zwecken zur Datenerhebung.
    </p>
    
    <h2>5. Verarbeitungen durch Cookies</h2>
    <p>Es werden keine Cookies verwendet.</p>
    <p>Wir setzen auf unserer Internetseite weder technisch notwendige noch andere Formen von Cookies ein. Sie bekommen daher auch keinen Cookie-Hinweis zu sehen und es werden keine Einwilligungen zur Nutzung von Cookies eingeholt.</p>
    
    <h2>6. Weitere Empfänger Ihrer personenbezogenen Daten</h2>
    <p>
    Ihre personenbezogenen Daten, übermitteln wir nur dann an weitere Empfänger oder gewähren weiteren Empfängern nur dann Zugriff auf Ihre personenbezogenen Daten, sofern dies für die jeweiligen Zwecke der Verarbeitung dieser personenbezogenen erforderlich ist oder sofern wir weitere Empfänger mit der Erfüllung von einzelnen Aufgaben oder Dienstleistungen betraut haben und hierdurch ein Zugriff auf diese personenbezogenen Daten erforderlich oder nicht auszuschließen ist.
    </p>
    
    <h2>7. Datenübermittlung in Drittländer</h2>
    <p>
    In einigen Fällen kann eine Übermittlung personenbezogener Daten in einem Drittland erforderlich sein. In diesen Fällen leiten wir Ihre personenbezogenen Daten ausschließlich mit Ihrer Einwilligung (Art. 49 Abs. 1 lit. a DSGVO).

In manchen Fällen verwenden wir auf unserer Webseite Dienste, die in Drittländern gehostet werden oder durch die Daten in Drittländern verarbeitet werden. Nicht immer können diese Drittländer einen angemessenen Datenschutzstandard nachweisen (Angemessenheitsbeschluss), sie gelten daher als datenschutzrechtlich unsicher. Mit den Anbietern der Dienste wurden daher Standardvertragsklauseln gemäß Art. 46 Abs. 2 lit. c DSGVO geschlossen. 
    </p>
    
    <h2>8. Automatisierte Entscheidungen einschließlich Profiling</h2>
    <p>
    Automatisierte Entscheidungsfindungen einschließlich Profiling gemäß Artikel 22 Abs. 1, 4 DSGVO finden im Rahmen Ihres Besuchs dieser Webseite nicht statt.
    </p>
    
    <h2>9. Technik</h2>
    <h3>9.1 SSL/TLS-Verschlüsselung</h3>
    <p>
    Diese Seite nutzt zur Gewährleistung der Sicherheit der Datenverarbeitung und zum Schutz der Übertragung vertraulicher Inhalte, wie zum Beispiel Login-Daten oder Kontaktanfragen, die Sie an uns als Betreiber senden, eine SSL-bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass in der Adresszeile des Browsers statt einem "http://" ein "https://" steht und an dem Schloss-Symbol in Ihrer Browserzeile.

Wir setzen diese Technologie ein, um Ihre übermittelten Daten zu schützen.
    </p>
    
    <h3>9.2 Hosting durch Strato</h3>
    <p>
    Wir hosten unsere Webseite bei der Strato AG, Otto-Ostrowski-Straße 7, 10249 Berlin (nachfolgend: „Strato“).

Wenn Sie unsere Webseite besuchen, werden Ihre personenbezogenen Daten (z.B. IP-Adressen in Logfiles) auf den Servern von Strato verarbeitet. 

Die Verwendung von Strato erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f) DS-GVO. Wir haben ein berechtigtes Interesse an einer möglichst zuverlässigen Darstellung und Bereitstellung sowie Absicherung unserer Webseite.

Wir haben einen Vertrag zur Auftragsverarbeitung (AVV) gem. Art. 28 DS-GVO mit Strato geschlossen. Hierbei handelt es sich um einen datenschutzrechtlich vorgeschriebenen Vertrag, der gewährleistet, dass Strato die personenbezogenen Daten unserer Webseitenbesucher nur nach unseren Weisungen und unter Einhaltung der DS-GVO verarbeitet.

Nähere Informationen zu Datenschutzbestimmungen von Strato finden Sie unter: https://www.strato.de/datenschutz/. 
    </p>
    
    <h2>10. Inhalte unserer Internetseite</h2>
    <h3>10.1 Kontaktaufnahme / Kontaktformular</h3>
    <p>
    Im Rahmen der Kontaktaufnahme mit uns (z.B. per Kontaktformular oder E-Mail) werden personenbezogene Daten erhoben. Welche Daten im Falle der Nutzung eines Kontaktformulars erhoben werden, ist aus dem jeweiligen Kontaktformular ersichtlich. 

Diese Daten werden ausschließlich zum Zwecke der Beantwortung Ihres Anliegens bzw. für die Kontaktaufnahme und die damit verbundene technische Administration gespeichert und verwendet. 

Rechtsgrundlage für die Verarbeitung der Daten ist unser berechtigtes Interesse an der Beantwortung Ihres Anliegens gemäß Art. 6 Abs. 1 lit. f) DS-GVO. Zielt Ihre Kontaktaufnahme auf den Abschluss eines Vertrages ab, so ist zusätzliche Rechtsgrundlage für die Verarbeitung Art. 6 Abs. 1 lit. b) DS-GVO. 

Ihre Daten werden nach abschließender Bearbeitung Ihrer Anfrage gelöscht, dies ist der Fall, wenn sich aus den Umständen entnehmen lässt, dass der betroffene Sachverhalt abschließend geklärt ist und der Löschung keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
    </p>
    
    <h3>10.2 Bewerbungsmanagement</h3>
    <p>
    Wir erheben und verarbeiten die personenbezogenen Daten von Bewerbern zum Zwecke der Abwicklung des Bewerbungsverfahrens. Die Verarbeitung kann auch auf elektronischem Wege erfolgen. Dies ist insbesondere dann der Fall, wenn ein Bewerber entsprechende Bewerbungsunterlagen auf dem elektronischen Wege, beispielsweise per E-Mail, an uns übermittelt. 

Schließen wir einen Arbeits- oder Dienstvertrag mit einem Bewerber, werden die übermittelten Daten zum Zwecke der Abwicklung des Beschäftigungsverhältnisses unter Beachtung der gesetzlichen Vorschriften gespeichert. 

Wird von uns kein Vertrag mit dem Bewerber geschlossen, so werden die Bewerbungsunterlagen 6 Monat nach Bekanntgabe der Absageentscheidung automatisch gelöscht.

Die Rechtsgrundlage der Verarbeitung Ihrer Daten ist Art. 6 Abs. 1 lit. b), 88 DS-GVO i.V.m. § 26 Abs. 1 BDSG.
    </p>
    
    <h2>11. Ihre Rechte als betroffene Person</h2>
    <p>Im Allgemeinen und in Bezug auf Ihre personenbezogenen Daten können Sie die im Folgenden benannten Rechte ausüben.</p>

    <h3>11.1 Recht auf Auskunft gemäß Art. 15 DS-GVO</h3>
    <p>
    Sie haben das Recht, vom Verantwortlichen Auskunft über die zu Ihrer Person gespeicherten personenbezogenen Daten und weitere Informationen in Bezugnahme auf diese personenbezogenen Daten zu verlangen.
    </p>
    
    <h3>11.2 Recht auf Berichtigung gemäß Art. 16 DS-GVO</h3>
    <p>
    Sie haben das Recht, vom Verantwortlichen unverzüglich die Berichtigung Ihre Person betreffende unrichtiger personenbezogener Daten zu verlangen. 
    </p>
    
    <h3>11.3 Recht auf Löschung gemäß Art. 17 DS-GVO</h3>
    <p>Sie haben das Recht, vom Verantwortlichen die unverzügliche Löschung Ihre Person betreffende personenbezogener Daten zu verlangen. </p>
    
    <h3>11.4 Recht auf Einschränkung der Verarbeitung gemäß Art. 18 DS-GVO</h3>
    <p>Sie haben das Recht, vom Verantwortlichen die Einschränkung der Verarbeitung Ihre Person betreffende personenbezogener Daten zu verlangen. </p>
    
    <h3>11.5 Recht auf Datenübertragbarkeit gemäß Art. 20 DS-GVO</h3>
    <p>Sie haben das Recht, vom Verantwortlichen Ihre personenbezogenen Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten. </p>
    
    <h3>11.6 Recht auf Widerruf gemäß Art. 7 Abs. 3 DS-GVO</h3>
    <p>Sie haben das Recht, Ihre gemäß Art. 6 Abs. 1 lit. a DS-GVO erteilte Einwilligung zur Verarbeitung Ihrer personenbezogenen Daten jederzeit zu widerrufen. Die Rechtmäßigkeit, der aufgrund Ihrer Einwilligung bis zu deren Widerruf erfolgten Verarbeitungen Ihrer personenbezogenen Daten, wird hierdurch nicht berührt.</p>
    
    <h3>11.7 Recht auf Widerspruch gemäß Art. 21 Abs. 1 DS-GVO</h3>
    <p>Sie haben das Recht, einer gemäß Art. 6 Abs. 1 lit. e oder f DS-GVO erfolgenden Verarbeitung Ihrer personenbezogenen Daten jederzeit zu widersprechen.</p>
    
    <h3>11.8 Recht auf Beschwerde bei einer Aufsichtsbehörde gemäß Art. 77 DS-GVO</h3>
    <p>
    Sofern Sie als betroffene Person der Ansicht sind, dass eine Verarbeitung Ihrer personenbezogenen Daten gegen die DS-GVO verstößt, so haben Sie das Recht auf Beschwerde bei einer Aufsichtsbehörde, insbesondere in dem Mitgliedstaat ihres Aufenthaltsorts, ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes. Eine Liste der Aufsichtsbehörden in Deutschland (für den nichtöffentlichen Bereich) samt Anschrift 
finden Sie unter:
https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html.
    </p>
    
    <h2>12. Dauer der Speicherung von personenbezogenen Daten</h2>
    <p>
    Wir verarbeiten und speichern Ihre personenbezogenen Daten nur für den Zeitraum, der zur Erreichung des Speicherungszwecks erforderlich ist oder sofern dies durch die Rechtsvorschriften, welchen unser Unternehmen unterliegt, vorgesehen wurde.

Entfällt der Speicherungszweck oder läuft eine vorgeschriebene Speicherfrist ab, werden die personenbezogenen Daten routinemäßig und entsprechend den gesetzlichen Vorschriften gelöscht.

    </p>


        </div>
    )
}

export default Datenschutz
